/**
 * Ryan O'Dowd
 * 2022-03-21
 * © Copyright 2022 Oakwood Software Consulting, Inc. All Rights Reserved.
 */
import {
  Platform,
} from 'react-native';
import globals from '@utils/globals';

const getStyles = ({globalScale, colors, isDarkMode}) => {
  // @TODO: this is janky; i don't understand this math either...this is just hardcoded from visual tweaking {
  let disabledProgressBarHeight = 39;
  let disabledProgressBarTop = -38;
  let disabledProgressBorderRadius = 12;
  if (globalScale === globals.fontScales.small) {
    disabledProgressBarHeight = 45;
    disabledProgressBarTop = -36;
    disabledProgressBorderRadius = 14;
  } else if (globalScale === globals.fontScales.large) {
    disabledProgressBarHeight = 34;
    disabledProgressBarTop = -46;
    disabledProgressBorderRadius = 10;
  } else if (globalScale === globals.fontScales.extraLarge) {
    disabledProgressBarHeight = 30;
    disabledProgressBarTop = -52;
    disabledProgressBorderRadius = 8;
  }
  // @TODO: this is janky }

  return {
    container: {
      flexGrow: 1,
      width: '100%',
      alignItems: 'center',
      justifyContent: 'flex-start',
    },
    innerContainer: {
      flexGrow: 1,
      width: '100%',
    },
    innerContainerContent: {
      flexGrow: 1,
    },
    minigameContainer: {
      flex: 1,
      alignItems: 'center',
      justifyContent: 'center',
      padding: 16,
      // @TODO: padding: globalScale * 16,
    },
    scrollWrapper: {
      flex: 1,
      width: '100%',
      borderRadius: globalScale * 16,
      borderWidth: globalScale * 6,
      backgroundColor: `${isDarkMode ? colors.primaryDark : colors.primary}cc`,
      borderColor: isDarkMode ? colors.primaryLight : colors.primaryDark,
    },
    scrollWrapperTests: {
      borderColor: isDarkMode ? colors.primaryLight : colors.primaryDark,
    },
    minigameInnerContainer: {
      flexGrow: 1,
      height: Platform.OS === 'web' ? 100 : undefined, // @TODO: for some reason, web needs this in order to not overflow...100 is too small though, so this is very weird
      alignItems: 'center',
      justifyContent: 'space-evenly',
      padding: globalScale * 8,
    },
    minigameInnerContainerTests: {
      paddingHorizontal: 0,
      paddingBottom: 0,
    },
    buttonWrapper: {
      display: 'flex',
      width: '100%',
      paddingTop: 16,
    },
    actionsWrapper: {
      flexDirection: 'row',
      justifyContent: 'center',
      alignItems: 'center',
    },
    continueButtonWrapper: {
      display: 'flex',
      flexGrow: 1,
    },
    mainButton: {
      width: '100%',
      borderRadius: globalScale * 12,
    },
    progressBarWrapper: {
      opacity: 0.3,
    },
    disabledProgressBar: {
      position: 'absolute',
      top: disabledProgressBarTop,
      height: globalScale * disabledProgressBarHeight,
      backgroundColor: colors.white,
      borderRadius: globalScale * disabledProgressBorderRadius,
    },
    reportIcon: {
      margin: 0,
      marginRight: 8,
    },
    incorrectInnerContainer: {
      borderColor: colors.incorrect,
    },
    correctInnerContainer: {
      borderColor: colors.accent,
    },
    mixedCorrectnessInnerContainer: {
      borderColor: colors.complete,
    },
    incorrectButton: {
      backgroundColor: colors.incorrect,
    },
    correctButton: {
      backgroundColor: colors.accent,
    },
    mixedCorrectnessButton: {
      backgroundColor: colors.complete,
    },
    dialogText: {
      marginBottom: globalScale * 16,
    },
  };
};

export default getStyles;
